import React from 'react'
import ContactoBanner from '../../shared/contactBanner/contacto-banner'
import Banner from '../../shared/banners/banner'
import banner from '../../../assets/images/gestionproductos/banner.png'
import Enfoque from './enfoque'
import ListaEnfoque from './listaEnfoque'
import FraseDestacada from '../../shared/banners/fraseDestacada'

const GestionProductos = (): any => {
  // Dividir el texto antes y después del salto de línea
  const texto = 'Porque un producto exitoso no es el más complejo, sino el que logra lo que se propone. Y eso, lo gestionamos.'
  const textoAntesDelSalto = texto.split('Y eso, lo gestionamos.')[0]
  const textoDespuesDelSalto = 'Y eso, lo gestionamos.' // Parte posterior al salto de línea
  const textoAntesDelSaltoMovil = texto.split('sino el que logra lo que se propone. Y eso, lo gestionamos.')[0]
  const textoDespuesDelSaltoMovil = 'sino el que logra lo que se propone. Y eso, lo gestionamos.' // Parte posterior al salto de línea

  return (
    <div className='flex flex-col items-center justify-center relative'>
      <div className='sticky top-0'>
        <Banner image={banner} title='Gestión de productos' description='De la idea al impacto'/>
      </div>
      <div className='sticky top-0 bg-white w-full'>
        <Enfoque />
        <ListaEnfoque />
        <div className='hidden md:block '>
          {/* Pasamos las dos partes del texto a FraseDestacada */}
          <FraseDestacada
            textClassName='text-center !text-[16px] md:!text-[36px] '
            texto={<><span>{textoAntesDelSalto}</span><br/><span>{textoDespuesDelSalto}</span></>}
          />
        </div>
        <div className='block md:hidden'>
          {/* Pasamos las dos partes del texto a FraseDestacada */}
          <FraseDestacada
            textClassName='text-center !text-[16px] md:!text-[36px] '
            texto={<><span>{textoAntesDelSaltoMovil}</span><br/><span>{textoDespuesDelSaltoMovil}</span></>}
          />
        </div>
        <ContactoBanner/>
      </div>
    </div>
  )
}

export default GestionProductos
